import axios from 'axios';

export const notesAPI = {
  getAll: (params = {}) => axios.get('/notes', { params }),
  getOne: (id) => axios.get(`/notes/${id}`),
  create: (data) => axios.post('/notes', data),
  update: (id, data) => axios.put(`/notes/${id}`, data),
  delete: (id) => axios.delete(`/notes/${id}`),
  getStats: () => axios.get('/notes/stats/overview'),
};

export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const now = new Date();
  const diff = now - date;
  const mins = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);

  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined });
};

export const stripHtml = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

export const NOTE_COLORS = [
  '#1a1a2e', '#0d1b2a', '#1a1200', '#0a1f0a', '#1a0a1a',
  '#1e0a0a', '#0a1a1a', '#1a0f00', '#12001a', '#001a12',
];

export const NOTE_TYPES = [
  { value: 'note', label: 'Note', icon: '📝' },
  { value: 'journal', label: 'Journal', icon: '📔' },
  { value: 'code', label: 'Code', icon: '💻' },
  { value: 'todo', label: 'To-Do', icon: '✅' },
];
